{
  "ID": 30,
  "fields": {
    "isGUID": true,
    "isAgentNumber": true,
    "isPartition": true,
    "isDescription": true,
    "advanced": {
      "isCallCentreLicenceType": false,
      "isInternalNumber": true,
      "isCiscoCommonID": false,
      "isOverrideMonitoring": false,
      "isWebexCallingUserID": false,
      "isBroadworksUserID": false,
      "isOwningGroupID": false,
      "isOidOnTelServer": false,
      "isOwningDepartment": true,
      "isTeamsUserID": true,
      "isUserPrincipalName": true
    },
    "omnichannel": {
      "isAllowAnsweringConcurrentChannels": true,
      "chatIntegration": {
        "isType": true,
        "isId": true
      },
      "emailIntegration": {
        "isType": true,
        "isEmailAddress": true,
        "isId": true
      }
    },
    "isUpdateDuplicateItems": true
  }
}